import React, { useState, useEffect } from "react";
import {
  IconButton,
  Tooltip,
  Badge,
  Box,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  HStack,
} from "@chakra-ui/react";
import { FaBell } from "react-icons/fa";
import Translate from "../LanguageTranslation/Translate";
import {
  pendingInvitesCount,
  pendingInvites,
  acceptInvite,
  rejectInvite,
} from "../../api/invites";

const BellWithBadge = ({fetchTrips}) => {
  const [badge, setBadge] = useState(0);
  const [list, setList] = useState([]);
  const modal = useDisclosure();

  const refreshBadge = async () => {
    try {
      const { data } = await pendingInvitesCount();
      setBadge(data.data.count);
    } catch {
      setBadge(0);
    }
  };

  const loadInvites = async () => {
    try {
      const { data } = await pendingInvites();
      // console.log("loadInvites", data);
      setList(data.data ?? []);
    } catch {
      setList([]);
    }
  };

  const openModal = () => {
    loadInvites();
    modal.onOpen();
  };

  const respond = async (id, action) => {
    try {
      if (action === "accept") {
        await acceptInvite(id);
        if (fetchTrips) fetchTrips();
      } else {
        await rejectInvite(id);
      }
      loadInvites();
      refreshBadge();
    } catch {
      // ignore
    }
  };

  useEffect(() => {
    refreshBadge();
  }, []);

  return (
    <>
      <Tooltip label={<Translate text="Pending Invites" />}>
        <IconButton
          size="sm"
          bg="none"
          _hover={{ bg: "none" }}
          aria-label="Invites"
          icon={
            <Box position="relative">
              <FaBell />
              {badge > 0 && (
                <Badge
                  position="absolute"
                  top="-1"
                  right="-1"
                  bg="red.500"
                  color="white"
                  borderRadius="full"
                  fontSize="0.6em"
                  px="1"
                >
                  {badge}
                </Badge>
              )}
            </Box>
          }
          onClick={openModal}
        />
      </Tooltip>

      <Modal
        isOpen={modal.isOpen}
        onClose={modal.onClose}
        size={{ base: "sm", md: "3xl" }}
      >
        <ModalOverlay />
        <ModalContent maxH="80vh" overflowY="auto" w="100%" overflowX="auto">
          <ModalHeader>
            <Translate text="Pending Invitations" />
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {list.length === 0 ? (
              <Text>
                <Translate text="Nothing yet." />
              </Text>
            ) : (
              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th>
                      <Translate text="Trip" />
                    </Th>
                    <Th>
                      <Translate text="Invited By" />
                    </Th>
                    <Th>
                      <Translate text="Invited For" />
                    </Th>
                    <Th></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {list.map((inv) => (
                    <Tr key={inv._id || inv.id}>
                      <Td>{inv.trip_name}</Td>
                      <Td>{inv.invited_by}</Td>
                      <Td>
                        <Text fontSize="sm" mb={0}>
                          {inv.resource_types
                            ? inv.resource_types
                                .map(resource => resource
                                  .split("_")
                                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                  .join(" ")
                                )
                                .join(", ")
                            : "Itinerary"}
                        </Text>
                      </Td>
                      <Td>
                        <HStack>
                          <Button
                            size="xs"
                            colorScheme="customGreen"
                            onClick={() => respond(inv._id, "accept")}
                          >
                            <Translate text="Accept" />
                          </Button>
                          <Button
                            size="xs"
                            colorScheme="red"
                            onClick={() => respond(inv._id, "reject")}
                          >
                            <Translate text="Reject" />
                          </Button>
                        </HStack>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            )}
          </ModalBody>
          <ModalFooter>
            <Button onClick={modal.onClose}>
              <Translate text="Close" />
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default BellWithBadge;
